import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessages = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M42.5079 10.5106C43.8735 12.8758 43.8735 16.0514 43.8735 22.4024C43.8735 28.7534 43.8735 31.9289 42.5079 34.2942C41.6133 35.8437 40.3265 37.1305 38.777 38.0251C36.4117 39.3907 33.2362 39.3907 26.8852 39.3907H20.0899C18.1758 39.3907 16.5502 39.3907 15.1482 39.3533L8.21283 43.47C7.49792 43.8944 6.60302 43.3304 6.67733 42.5024L7.14203 37.3244C6.06046 36.5056 5.1497 35.4764 4.46717 34.2942C3.10156 31.9289 3.10156 28.7534 3.10156 22.4024C3.10156 16.0514 3.10156 12.8758 4.46716 10.5106C5.36179 8.96103 6.64852 7.67429 8.19805 6.77967C10.5633 5.41406 13.7388 5.41406 20.0899 5.41406L26.8852 5.41406C33.2362 5.41406 36.4117 5.41406 38.777 6.77966C40.3265 7.67428 41.6133 8.96102 42.5079 10.5106Z",
			fill: "url(#paint0_linear_198_9943)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 10.8386,
			y: 9.75659,
			width: 52.4775,
			height: 49.8823,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(2.93px)",
					clipPath: "url(#bgblur_0_198_9943_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 5.85279,
			d: "M45.86 49.116L45.7336 49.0393L45.5858 49.0437C44.1515 49.0859 42.4757 49.086 40.475 49.086H33.6797C30.495 49.086 28.1399 49.0855 26.2843 48.9173C24.4356 48.7498 23.1318 48.4189 22.0379 47.7874C20.5644 46.9366 19.3408 45.713 18.49 44.2395C17.8585 43.1456 17.5276 41.8418 17.3601 39.9931C17.1919 38.1375 17.1914 35.7824 17.1914 32.5977C17.1914 29.413 17.1919 27.0579 17.3601 25.2023C17.5276 23.3535 17.8585 22.0497 18.49 20.9559C19.3408 19.4823 20.5644 18.2587 22.0379 17.408C23.1318 16.7764 24.4356 16.4456 26.2843 16.278C28.1399 16.1099 30.495 16.1094 33.6797 16.1094L40.4751 16.1094C43.6598 16.1094 46.0149 16.1099 47.8705 16.278C49.7192 16.4456 51.023 16.7764 52.1169 17.408C53.5904 18.2587 54.814 19.4823 55.6647 20.9559C56.2963 22.0497 56.6271 23.3535 56.7947 25.2023C56.9629 27.0579 56.9634 29.413 56.9634 32.5977C56.9634 35.7824 56.9629 38.1375 56.7947 39.9931C56.6271 41.8418 56.2963 43.1456 55.6647 44.2395C55.0157 45.3636 54.1497 46.3423 53.1212 47.121L52.9002 47.2883L52.925 47.5643L53.3875 52.7179C53.4256 53.1421 52.9649 53.4293 52.6008 53.2082L45.86 49.116Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_198_9943)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 19.9537,
			y: 18.8927,
			width: 34.638,
			height: 17.3191,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.46px)",
					clipPath: "url(#bgblur_1_198_9943_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 6.92764,
			x: 47.5366,
			y: 25.9478,
			width: 3.20894,
			height: 20.528,
			rx: 1.60447,
			transform: "rotate(90 47.5366 25.9478)",
			fill: "url(#paint2_linear_198_9943)",
			fillOpacity: .9,
			stroke: "url(#paint3_linear_198_9943)",
			strokeWidth: .254876
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 19.9552,
			y: 29.088,
			width: 29.785,
			height: 17.6785,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.46px)",
					clipPath: "url(#bgblur_2_198_9943_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 6.92764,
			x: 42.6851,
			y: 36.1431,
			width: 3.56826,
			height: 15.6749,
			rx: 1.78413,
			transform: "rotate(90 42.6851 36.1431)",
			fill: "url(#paint4_linear_198_9943)",
			fillOpacity: .9,
			stroke: "url(#paint5_linear_198_9943)",
			strokeWidth: .254876
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_9943_clip_path",
				transform: "translate(-10.8386 -9.75659)",
				children: /* @__PURE__ */ _jsx("path", { d: "M45.86 49.116L45.7336 49.0393L45.5858 49.0437C44.1515 49.0859 42.4757 49.086 40.475 49.086H33.6797C30.495 49.086 28.1399 49.0855 26.2843 48.9173C24.4356 48.7498 23.1318 48.4189 22.0379 47.7874C20.5644 46.9366 19.3408 45.713 18.49 44.2395C17.8585 43.1456 17.5276 41.8418 17.3601 39.9931C17.1919 38.1375 17.1914 35.7824 17.1914 32.5977C17.1914 29.413 17.1919 27.0579 17.3601 25.2023C17.5276 23.3535 17.8585 22.0497 18.49 20.9559C19.3408 19.4823 20.5644 18.2587 22.0379 17.408C23.1318 16.7764 24.4356 16.4456 26.2843 16.278C28.1399 16.1099 30.495 16.1094 33.6797 16.1094L40.4751 16.1094C43.6598 16.1094 46.0149 16.1099 47.8705 16.278C49.7192 16.4456 51.023 16.7764 52.1169 17.408C53.5904 18.2587 54.814 19.4823 55.6647 20.9559C56.2963 22.0497 56.6271 23.3535 56.7947 25.2023C56.9629 27.0579 56.9634 29.413 56.9634 32.5977C56.9634 35.7824 56.9629 38.1375 56.7947 39.9931C56.6271 41.8418 56.2963 43.1456 55.6647 44.2395C55.0157 45.3636 54.1497 46.3423 53.1212 47.121L52.9002 47.2883L52.925 47.5643L53.3875 52.7179C53.4256 53.1421 52.9649 53.4293 52.6008 53.2082L45.86 49.116Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_198_9943_clip_path",
				transform: "translate(-19.9537 -18.8927)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 47.5366,
					y: 25.9478,
					width: 3.20894,
					height: 20.528,
					rx: 1.60447,
					transform: "rotate(90 47.5366 25.9478)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_2_198_9943_clip_path",
				transform: "translate(-19.9552 -29.088)",
				children: /* @__PURE__ */ _jsx("rect", {
					x: 42.6851,
					y: 36.1431,
					width: 3.56826,
					height: 15.6749,
					rx: 1.78413,
					transform: "rotate(90 42.6851 36.1431)"
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_9943",
				x1: 43.8735,
				y1: 24.5145,
				x2: 3.10156,
				y2: 24.5145,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_9943",
				x1: 14.6528,
				y1: 18.3363,
				x2: 41.486,
				y2: 62.1041,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_198_9943",
				x1: 53.7246,
				y1: 23.3673,
				x2: 49.2643,
				y2: 43.1202,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .979167,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_198_9943",
				x1: 49.396,
				y1: 25.8203,
				x2: 49.396,
				y2: 46.6032,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_198_9943",
				x1: 47.8783,
				y1: 35.8448,
				x2: 46.1506,
				y2: 48.782,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .979167,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_198_9943",
				x1: 44.7241,
				y1: 36.0156,
				x2: 44.7241,
				y2: 51.9454,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgMessages);
export { ForwardRef as ReactComponent };
